// extracted by mini-css-extract-plugin
module.exports = {"overlay":"src-components-page-portfolio-portfolio-detail-detail-header-ActionDropdown-module__overlay--25JIU"};